export default __webpack_public_path__ + "static/media/account-circle-fill.376b2294.svg";